import React from 'react';

import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { PasswordFormField } from 'lib/form/fields/PasswordFormField';

export const PaytronixSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <>
                <SettingDisplay label="Host">
                    <TextFormField name="paytronixHost" />
                </SettingDisplay>
                <SettingDisplay label="Username">
                    <TextFormField name="paytronixUsername" />
                </SettingDisplay>
                <SettingDisplay label="Password">
                    <PasswordFormField name="paytronixPassword" />
                </SettingDisplay>
                <SettingDisplay label="Merchant ID">
                    <TextFormField type="number" name="paytronixMerchantId" />
                </SettingDisplay>
                <SettingDisplay label="Card Template Code">
                    <TextFormField type="number" name="paytronixCardTemplateCode" />
                </SettingDisplay>
                <SettingDisplay label="Store Code">
                    <TextFormField name="paytronixStoreCode" />
                </SettingDisplay>
            </>
        )}
    </>
);
